<template>
  <nav class="navbar navbar-expand fixed-top align-items-stretch">
    <div class="container">
      <a class="navbar-brand my-auto" href="/">
        <img src="../../assets/images/logo.png" alt="Trismoka" height="37" />
        <span
          v-if="environment && environment != 'production'"
          class="ml-2 text-uppercase"
          style="font-size: 0.8rem; font-weight: 600"
          >{{ environment }}</span
        >
      </a>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto" v-if="currentUser">
          <li class="nav-item my-auto active">
            <router-link
              :to="{ name: 'dashboard' }"
              :class="{ active: $isRouteActive('dashboard') }"
              >Dashboard</router-link
            >
          </li>
          <li class="nav-item my-auto">
            <router-link
              :to="{ name: 'places' }"
              :class="{ active: $isRouteActive('places') }"
              >Rubrica</router-link
            >
          </li>
          <li class="nav-item my-auto">
            <router-link
              :to="{ name: 'video_tutorials' }"
              :class="{ active: $isRouteActive('video_tutorials') }"
              >Video Tutorials</router-link
            >
          </li>
          <li class="nav-item my-auto" v-if="isAdmin || isManager">
            <router-link
              :to="{ name: 'places_map' }"
              :class="{ active: $isRouteActive('places_map') }"
              >Mappa contatti</router-link
            >
          </li>
          <li class="nav-item my-auto" v-if="isAdmin || isManager">
            <router-link
              :to="{ name: 'clients_map' }"
              :class="{ active: $isRouteActive('clients_map') }"
              >Mappa clienti</router-link
            >
          </li>
          <li class="nav-item my-auto">
            <router-link
              :to="{ name: 'settings' }"
              :class="{ active: $isRouteActive('settings') }"
              v-if="['admin', 'manager'].indexOf(currentUser.role) !== -1"
              >Impostazioni</router-link
            >
          </li>
          <notification-dropdown />

          <li
            class="nav-item my-auto ml-4 dropdown"
            v-click-outside="onOutsideClick"
          >
            <a
              class="nav-link dropdown-toggle border rounded"
              @click="dropdownOpen = !dropdownOpen"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span class="step">{{ userRole }}</span>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right p-0"
              :class="{ show: dropdownOpen }"
              aria-labelledby="navbarDropdown"
            >
              <label class="px-3 pt-3 m-0 text-bold">
                <strong>Utente:</strong>
              </label>
              <p class="p-3 m-0 border-bottom text-secondary">
                {{ currentUser.email }}
              </p>
              <a
                class="dropdown-item p-3 text-danger clickable text-uppercase"
                @click="_logout()"
                >Logout</a
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { User } from "models";
import NotificationDropdown from "components/Notification/Dropdown.vue";
import { State, Getter, Action, Mutation } from "vuex-class";
import store from "store";
import ActivityRecipientList from "components/ActivityRecipient/List.vue";
import ClickOutside from "directives/ClickOutside";

@Component({
  components: { ActivityRecipientList, NotificationDropdown },
  directives: { ClickOutside },
})
export default class Navbar extends Vue {
  @Getter currentUser?: User;
  @Getter token;

  dropdownOpen: boolean = false;
  notificationsOpen: boolean = false;

  get userRole() {
    return this.currentUser ? User.getRoleLabel(this.currentUser.role) : "";
  }

  get isAdmin() {
    return (
      this.currentUser?.role === "admin" ||
      this.currentUser?.role === "super_admin"
    );
  }

  get environment(): string | undefined {
    return this.currentUser?.environment;
  }

  get isManager() {
    return this.currentUser?.role === "manager";
  }

  _logout() {
    store.dispatch("logout").then(() => {
      window.location.reload();
    });
  }

  onOutsideClick() {
    this.dropdownOpen = false;
  }
}
</script>

<style lang="scss" scoped></style>
